// extracted by mini-css-extract-plugin
export default {"btn":"RectangleButton_btn__CA1e8","btn-primary":"RectangleButton_btn-primary__wA6DZ"};